import { AsyncButton, formatQuestionDefaults, QuestionInputs, SaveStates } from '@infl-ts/ui-advocate-components';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import * as E from 'fp-ts/Either';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import StageLayout from '../stage-layout';
import { jsx as _jsx } from "react/jsx-runtime";

var updateProfileQuestions = function updateProfileQuestions(profile, t) {
  return [{
    __typename: 'ImageUploadQuestion',
    id: 'file',
    required: false,
    subject: t('Profile Image'),
    responseIsPublic: true,
    currentValue: profile.avatarUrl
  }, {
    __typename: 'ShortAnswerQuestion',
    id: 'title',
    required: false,
    subject: t('Title'),
    responseIsPublic: false,
    currentValue: profile.title
  }, {
    __typename: 'ShortAnswerQuestion',
    id: 'company',
    required: false,
    subject: t('Company'),
    responseIsPublic: false,
    currentValue: profile.company
  }];
};

export var UpdateProfile = function UpdateProfile(_ref) {
  var stage = _ref.stage,
      activity = _ref.activity,
      profile = _ref.profile,
      completeStage = _ref.completeStage,
      completeStageStatus = _ref.completeStageStatus,
      prospect = _ref.prospect;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var questions = updateProfileQuestions(profile, t);
  var profileForm = useForm({
    defaultValues: formatQuestionDefaults(questions)
  });
  useEffect(function () {
    profileForm.reset(formatQuestionDefaults(questions));
  }, [stage.id]);
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(completeStageStatus, function (_ref2) {
    var completeStage = _ref2.completeStage;
    return completeStage.__typename === 'CompleteStageErrors' ? E.left(completeStage) : E.right(completeStage);
  }, [Saving, Success, Error, Default]);
  return /*#__PURE__*/_jsx(StageLayout, {
    showPublicResponseMessage: true,
    stage: stage,
    prospect: prospect,
    actions: /*#__PURE__*/_jsx(AsyncButton, {
      status: mutationValue,
      onClick: profileForm.handleSubmit(function (_ref3) {
        var file = _ref3.file,
            company = _ref3.company,
            title = _ref3.title;
        return completeStage({
          updateProfileInput: {
            stageID: stage.id,
            activityID: activity === null || activity === void 0 ? void 0 : activity.id,
            file: file ? {
              url: file.url
            } : null,
            title: title,
            company: company
          }
        });
      }),
      text: ['Submitting...', 'Saved', stage.completionText || 'Next', 'Next']
    }),
    "data-element": "StageLayout",
    "data-component": "UpdateProfile",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(QuestionInputs, {
      questions: questions,
      questionForm: profileForm,
      "data-element": "QuestionInputs",
      "data-component": "UpdateProfile",
      "data-source-file": "index.tsx"
    })
  });
};